// src/admin/AdminLayout.jsx
import React from "react";
import { Layout, Menu, Avatar } from "antd";
import {
  DashboardOutlined, CarOutlined, UserOutlined,
  ProfileOutlined, TeamOutlined, LogoutOutlined,
} from "@ant-design/icons";
import { useNavigate, Outlet, useLocation } from "react-router-dom";

const { Sider, Header, Content } = Layout;

const NAV_ITEMS = [
  { key:"dashboard", icon:<DashboardOutlined />, label:"Dashboard" },
  { key:"drivers",   icon:<UserOutlined />,      label:"Drivers"   },
  { key:"cabs",      icon:<CarOutlined />,        label:"Cabs"      },
  { key:"bookings",  icon:<ProfileOutlined />,    label:"Bookings"  },
  { key:"users",     icon:<TeamOutlined />,       label:"Users"     },
];

const PAGE_TITLES = {
  dashboard:"Dashboard",
  drivers:  "Drivers Management",
  cabs:     "Cabs Management",
  bookings: "Bookings Management",
  users:    "Users Management",
};

const AdminLayout = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const activeKey = location.pathname.split("/").pop() || "dashboard";
  const adminName = sessionStorage.getItem("adminName") || "Admin";

  const handleLogout = () => {
    sessionStorage.removeItem("adminLoggedIn");
    sessionStorage.removeItem("adminName");
    navigate("/admin/login");
  };

  return (
    <Layout style={{ minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>

      {/* ── Sidebar ── */}
      <Sider
        width={230}
        style={{
          background:"#0f172a",
          boxShadow:"4px 0 16px rgba(0,0,0,.15)",
          position:"sticky", top:0,
          height:"100vh", overflow:"auto",
        }}
      >
        {/* Brand */}
        <div style={{ padding:"22px 20px 16px", borderBottom:"1px solid rgba(255,255,255,.08)" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:36, height:36, borderRadius:10, background:"linear-gradient(135deg,#f5c518,#d4a80f)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, fontWeight:900, color:"#1a1a2e" }}>M</div>
            <div>
              <div style={{ color:"#fff", fontWeight:800, fontSize:16, lineHeight:1.2 }}>HaloSorath</div>
              <div style={{ color:"rgba(255,255,255,.4)", fontSize:11, letterSpacing:"1px", textTransform:"uppercase" }}>Admin Panel</div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[activeKey]}
          onClick={e => navigate(`/admin/${e.key}`)}
          style={{ background:"transparent", border:"none", marginTop:8 }}
          items={NAV_ITEMS.map(item => ({
            key:   item.key,
            icon:  item.icon,
            label: item.label,
            style: {
              borderRadius: 10,
              margin:       "2px 10px",
              width:        "calc(100% - 20px)",
              fontWeight:   activeKey === item.key ? 700 : 400,
            },
          }))}
        />

        {/* Bottom: back to site + logout */}
        <div style={{ position:"absolute", bottom:0, left:0, right:0, borderTop:"1px solid rgba(255,255,255,.08)" }}>
          <div
            onClick={() => navigate("/")}
            style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer", color:"rgba(255,255,255,.4)", fontSize:13, padding:"12px 20px", transition:"color .2s" }}
            onMouseEnter={e=>e.currentTarget.style.color="#f5c518"}
            onMouseLeave={e=>e.currentTarget.style.color="rgba(255,255,255,.4)"}
          >
            <span style={{ fontSize:15 }}>🌐</span> View Website
          </div>
          <div
            onClick={handleLogout}
            style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer", color:"rgba(239,68,68,.7)", fontSize:13, padding:"12px 20px", transition:"color .2s", borderTop:"1px solid rgba(255,255,255,.06)" }}
            onMouseEnter={e=>e.currentTarget.style.color="#ef4444"}
            onMouseLeave={e=>e.currentTarget.style.color="rgba(239,68,68,.7)"}
          >
            <LogoutOutlined style={{ fontSize:15 }} /> Logout
          </div>
        </div>
      </Sider>

      {/* ── Main ── */}
      <Layout>
        {/* Header */}
        <Header style={{
          background:"#fff", padding:"0 28px",
          display:"flex", justifyContent:"space-between", alignItems:"center",
          borderBottom:"1px solid #e5e7eb", boxShadow:"0 1px 8px rgba(0,0,0,.05)",
          position:"sticky", top:0, zIndex:10,
        }}>
          <div>
            <span style={{ fontWeight:700, fontSize:17, color:"#1a1a2e" }}>{PAGE_TITLES[activeKey] || "Admin"}</span>
            <span style={{ color:"#9ca3af", fontSize:13, marginLeft:12 }}>HaloSorath Admin Panel</span>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <span style={{ fontSize:13, color:"#6b7280" }}>{adminName}</span>
            <Avatar
              style={{ background:"linear-gradient(135deg,#f5c518,#d4a80f)", color:"#1a1a2e", fontWeight:800, cursor:"pointer" }}
              onClick={handleLogout}
              title="Click to logout"
            >
              {adminName[0]}
            </Avatar>
          </div>
        </Header>

        {/* Content */}
        <Content style={{ margin:24, minHeight:"calc(100vh - 112px)" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;